import { UncontrolledRecipientWellProps } from '../store/schema/UncontrolledRecipientWellProps';
import { observer } from 'mobx-react-lite';
import { RecipientWell } from 'owa-readwrite-recipient-well-fabric/lib/components/PeoplePickerTypes';
import updateEditedRecipient from 'owa-readwrite-recipient-well/lib/actions/updateEditedRecipient';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import * as React from 'react';

/**
 * This component is a recipient well based on the ExtendedPeoplePicker in Fabric
 */
const UncontrolledExtendedRecipientWellInner = (
    props: UncontrolledRecipientWellProps,
    originalRef: React.Ref<RecipientWell>
) => {
    const onItemEdited = React.useCallback(
        (recipient: ReadWriteRecipientViewState, updatedRecipient: ReadWriteRecipientViewState) => {
            updateEditedRecipient(recipient, updatedRecipient);
            props.onItemEdited?.(recipient, updatedRecipient);
        },
        [props.viewState]
    );

    return (
        <RecipientWell
            ref={originalRef}
            selectedItems={props.viewState.recipients}
            defaultSelectedItems={props.viewState.recipients.slice()}
            findControlViewState={props.viewState}
            useAsControlledComponent={true}
            {...props}
            inputProps={{ ...props.inputProps, defaultVisibleValue: props.viewState.queryString }}
            onItemsAdded={props.internalOnItemsAdded}
            onItemsRemoved={props.internalOnItemsRemoved}
            onItemEdited={onItemEdited}
        />
    );
};

/**
 * A component that renders a fabric recipient well against a viewstate,
 * and automatically updates the viewstate when the recipient well is interacted with.
 */
export const UncontrolledExtendedRecipientWell = observer(UncontrolledExtendedRecipientWellInner, {
    forwardRef: true,
});

export default UncontrolledExtendedRecipientWell;
